import { Router } from '@angular/router';
import { Component, Input, OnInit, ViewEncapsulation, OnDestroy, AfterViewInit, ViewChild, Output } from "@angular/core";
import { FormBuilder, Validators, FormControl, ValidatorFn, FormGroup, ValidationErrors } from "@angular/forms";
import { MainService } from "../../Services/service.service";
import { DTOAdvertisementCategory, DTORegion, DTOSubRegion, IDTOSubRegion, SubRegion } from "src/app/api/WickedApiClient";
import { scan, takeUntil } from "rxjs/operators";
import { GeolocationService } from "../../Services/geolocation.service";
import { Observable, Subscription, ReplaySubject, BehaviorSubject } from "rxjs";
import { CookieService } from "ngx-cookie-service";
import { SeoService } from "../../Services/seo.service";
import { SearchRouteService, Categories } from "../../Services/searchroute.service";
import { MatSelectSearchComponent } from 'ngx-mat-select-search';
import { RegexSearchList } from './../../Services/searchroute.service';

interface numberForSelect {
  value: number;
  viewValue: string;
}

enum SearchType { City, Zip }

@Component({
  selector: "app-search-small",
  templateUrl: "./search-small.component.html",
  styleUrls: ["./search-small.component.scss"],
  encapsulation: ViewEncapsulation.None
})
export class SearchSmallComponent implements OnInit, OnDestroy {

  private _searchType: SearchType = SearchType.City;

  public miles: numberForSelect[] = [
    { value: 0, viewValue: 'none' },
    { value: 10, viewValue: '10' },
    { value: 25, viewValue: '25' },
    { value: 50, viewValue: '50' },
    { value: 75, viewValue: '75' },
  ];

  get SearchType(): SearchType {
    return this._searchType;
  }

  set SearchType(value: SearchType) {
    this._searchType = value;
  }

  get SearchTypes() { return SearchType; }

  get withPicturesOnly(): boolean {
    return this._withPicturesOnly;
  }

  set withPicturesOnly(value: boolean) {
    this._withPicturesOnly = value;
  }

  get strBlogUrl() {
    return this.service.advService.blogURL
  }

  @Input()
  public set type(value: string) {
    this._type = value;
  }

  private changeSearchDataSubscription: Subscription;

  @Input() autoLocation: boolean = false;

  private _type: string = "home";
  public get type(): string {
    return this._type;
  }

  public regionFilter: FormControl = new FormControl();
  public subregionFilter: FormControl = new FormControl();

  public categories: Observable<DTOAdvertisementCategory[]>;;
  public regions: DTORegion[] = [];
  public subRegions: DTOSubRegion[] = [];
  public tmpSearchedSubRegions: DTOSubRegion[] = [];
 
  @ViewChild('citySearchSelect', {static: true}) citySearchSelect: MatSelectSearchComponent;
  public limit = 10;
  public offset = 0;
  public subRegionsOptions = new BehaviorSubject<DTOSubRegion[]>([]);
  public subRegionsOptions$: Observable<string[]>;

  public loading: boolean = false;


  private _withPicturesOnly: boolean = false;

  public advSearchForm = this.fb.group(
    {
      region: [null],
      subregion: [null],
      zipCode: [null, Validators.compose([Validators.minLength(5), Validators.maxLength(5)])],
      casualDating: [false],
      relationShips: [null],
      miles: [null],
      keywords: [null],
      withPicturesOnly: [null]
    },
    {
      validators: validateSubRegionAndZip
    }
  );

  getRouter() { return this.router };

  constructor(public router: Router, private fb: FormBuilder, public service: MainService, public geolocationService: GeolocationService, public cookieService: CookieService, private seo: SeoService, private searchRouteService: SearchRouteService) {

    this.subRegionsOptions$ = this.subRegionsOptions.asObservable().pipe(
      scan((acc, curr) => {
        if(curr.length === 0) return [];
        else return [...acc, ...curr];
        }, [])
    );

  }

  openedChange(opened){
    if(opened && !this.subregionFilter.value && this.subRegions.length > 0){
      this.getNextBatch(this.subRegions);
    }
  }

  ngOnInit(): void {

    this.service.selectedSearchParams =  this.advSearchForm;

    this.subregionFilter.valueChanges.subscribe((val) => {this.onSearchChange(val)});

    this.categories = this.service.advService.getCategoriesObservable();
    this.service.advService.getRegionsOnlyPromise().then(r => {
      this.regions = r;
    });
    this.service.advService.searchInActionChanged.subscribe(s => {
      this.loading = s;
    });

    this.service.advService.searchDataStandard.currentSearchRuleChanged.subscribe(data => {
      if (data.regionId) {
        this.subRegions = this.service.advService.getSubRegionsByRegionId(data.regionId);
      }
    });

    this.service.advService.searchDataStandard.currentSearchRuleChanged.subscribe(data => {
      if (this.isSearchRoute()) {
        if (!(data as any)._type) {
          this.advSearchForm.setValue({
            region: data.regionId || 0,
            subregion: data.subRegionId || 0,
            casualDating: data.casualDating || false,
            relationShips: data.advertisementCategoryId || 0,
            miles: data.miles || 50,
            zipCode: data.zipCode || "",
            keywords: data.keywords || "",
            withPicturesOnly: data.withPicturesOnly || false,
          });
        }
      } else {
        this.advSearchForm.setValue({
          region: data.regionId || 0,
          subregion: data.subRegionId || 0,
          casualDating: data.casualDating || false,
          relationShips: data.advertisementCategoryId || 0,
          miles: data.miles || 50,
          zipCode: data.zipCode || "",
          keywords: data.keywords || "",
          withPicturesOnly: data.withPicturesOnly || false,

        });
      }
    });

  }

  changeSearchType(event: MouseEvent) {
    event.preventDefault();
    if (this.SearchType == SearchType.City) {
      this.SearchType = SearchType.Zip;
    } else {
      this.SearchType = SearchType.City;
    }
  }

  clearSearch() {
    this.advSearchForm.controls["casualDating"].setValue(false);
    this.advSearchForm.controls["relationShips"].setValue(null);
    this.advSearchForm.controls['keywords'].setValue("");
    this.advSearchForm.controls["withPicturesOnly"].setValue(false);
    this.advSearchForm.controls["miles"].setValue("");
    this.advSearchForm.controls["zipCode"].setValue("");
    this.advSearchForm.controls["region"].setValue(null);
    this.advSearchForm.controls["subregion"].setValue(null);
  }

  isSearchRoute(): boolean {
    let regex = new RegExp(RegexSearchList, "gi");
    var regexMatch = regex.exec(this.router.url.replace("/", ""));
    if (regexMatch != null && (regexMatch as any).groups != null) {
      return true;
    } else {
      return false;
    }
  }

  ngOnDestroy(): void {
    if (this.changeSearchDataSubscription) {
      this.changeSearchDataSubscription.unsubscribe();
    }
  }

  get filteredSubregion(): DTOSubRegion[] {
    if (!this.subRegions) {
      return [];
    }
    let search = this.subregionFilter.value;
    if (!search) {
      return this.subRegions;
    } else {
      return this.subRegions.filter(r => r.name.toLowerCase().startsWith(search.toLowerCase()) || r.subRegionId == this.advSearchForm.controls["subregion"].value);
    }
  }
  
  getNextBatch(data) {
    const result = data.slice(this.offset, this.offset + this.limit);
    
    this.subRegionsOptions.subscribe(r => {
      const setFirstItemActivebk = this.citySearchSelect.matSelect._keyManager.setFirstItemActive;
      this.citySearchSelect.matSelect._keyManager.setFirstItemActive = () => {};
      // restoring setFirstItemActive fn
      setTimeout(() => {
        this.citySearchSelect.matSelect._keyManager.setFirstItemActive = setFirstItemActivebk;
      }, 1000);
    })
    
    if(result.length > 0){
      this.subRegionsOptions.next(result);
      this.offset += this.limit;
    }

  }

  callGetNextBatch(){
    if (this.subregionFilter.value) {
      this.getNextBatch(this.tmpSearchedSubRegions);
    } else {
      this.getNextBatch(this.subRegions);
    }
  }

  onSearchChange(e): void  {
    this.subRegionsOptions.next([]);
        let val = e ? e.trim() : null;
        if (!val) {
            this.offset = 0;
            this.tmpSearchedSubRegions = [];
            this.getNextBatch(this.subRegions);
            return;
        } else {
            val = val.toLowerCase();
            this.tmpSearchedSubRegions = this.filteredSubregion;
            this.subRegionsOptions.next(this.tmpSearchedSubRegions); 
        }
  }

  getRegionData(regionId: number) {
    return this.regions.find(r => r.regionId == regionId);
  }

  get filteredRegions(): DTORegion[] {
    if (!this.regions || this.regions.length == 0) {
      return [];
    }
    let search = this.regionFilter.value;
    if (!search) {
      return this.regions;
    } else {
      return this.regions.filter(r => r.name.toLowerCase().startsWith(search.toLowerCase()) || r.regionId == this.advSearchForm.controls["region"].value);
    }
  }

  setSelectedRegion(regionId: any) {
    if (regionId) {
      this.service.advService.getSubRegionsForRegionPromise(regionId).then((r)=>{
        this.subRegions =  r;
        this.advSearchForm.controls["subregion"].setValue(r[0].subRegionId);
        this.offset = 0;
        this.subRegionsOptions.next([]);
        this.getNextBatch(this.subRegions);
      });
    }
  }

  onSubmit(navigateToSearchResult: boolean = true, navigateURL: string = "search-results") {
    this.seo.updateMetaTagsBySearch(parseInt(this.advSearchForm.controls["relationShips"].value));
    if (this.advSearchForm.valid) {
      this.service.advService.searchDataStandard.currentSearchRule.pageNumber = 0;
      this.service.advService.searchDataStandard.currentSearchRule.regionId = this.SearchType == SearchType.City ? parseInt(this.advSearchForm.controls["region"].value) : null;
      if (isNaN(this.service.advService.searchDataStandard.currentSearchRule.regionId)) {
        this.service.advService.searchDataStandard.currentSearchRule.regionId = null;
      }
      this.service.advService.searchDataStandard.currentSearchRule.casualDating = this.advSearchForm.controls["casualDating"].value;
      this.service.advService.searchDataStandard.currentSearchRule.advertisementCategoryId = this.advSearchForm.controls["relationShips"].value;
      this.service.advService.searchDataStandard.currentSearchRule.subRegionId = this.SearchType == SearchType.City ? parseInt(this.advSearchForm.controls["subregion"].value) : null;
      if (isNaN(this.service.advService.searchDataStandard.currentSearchRule.subRegionId)) {
        this.service.advService.searchDataStandard.currentSearchRule.subRegionId = null;
      }
      this.service.advService.searchDataStandard.currentSearchRule.miles = this.SearchType == SearchType.City ? null : (this.advSearchForm.controls["miles"].value ? Number(this.advSearchForm.controls["miles"].value.value) : null);
      this.service.advService.searchDataStandard.currentSearchRule.zipCode = this.SearchType == SearchType.City ? null : this.advSearchForm.controls["zipCode"].value;
      this.service.advService.searchDataStandard.currentSearchRule.keywords = this.advSearchForm.controls["keywords"].value;
      this.service.advService.searchDataStandard.currentSearchRule.withPicturesOnly = this.advSearchForm.controls["withPicturesOnly"].value;

      if (navigateToSearchResult && navigateURL == "urlsearch" && this.service.advService.searchDataStandard.currentSearchRule.regionId != null && this.service.advService.searchDataStandard.currentSearchRule.subRegionId != null) {
        if (this.SearchType == SearchType.Zip) {
          this.service.advService.searchAction(true, "search-results");
        } else {
          var state = this.regions.find(r => r.regionId == this.service.advService.searchDataStandard.currentSearchRule.regionId);
          var city = this.subRegions.find(r => r.subRegionId == this.service.advService.searchDataStandard.currentSearchRule.subRegionId);
          var category = Object.keys(Categories)[Object.values(Categories).findIndex(x => x == this.service.advService.searchDataStandard.currentSearchRule.advertisementCategoryId)];
          var withPicture = this.service.advService.searchDataStandard.currentSearchRule.withPicturesOnly ? "-with-picture" : "";
          var casualDating = this.service.advService.searchDataStandard.currentSearchRule.casualDating ? "casual-dating" : "long-term";

          var url = `${state.shortName.toLowerCase()}-${city.name.replace(" ", "-").toLowerCase()}-${casualDating}${withPicture}`;
          if (category) {
            url = `${state.shortName.toLowerCase()}-${city.name.replace(" ", "-").toLowerCase()}-${casualDating}-${category.replace(" ", "-").toLowerCase()}${withPicture}`;
          }

          this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
            this.router.navigate([url]));
        }
      } else {
        if (this.SearchType == SearchType.Zip) {
          this.service.advService.searchAction(true, "search-results");
        } else {
          this.service.advService.searchAction(navigateToSearchResult, navigateURL);
        }
        
      }


    } else if (this.advSearchForm.errors && this.advSearchForm.errors.zipOrSubRegionReqired) {
      this.service.showWarning("Please enter City or Zip");
    };
  }
}

export const validateSubRegionAndZip: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
  const zipCode = control.get("zipCode").value;
  const subregion = control.get("subregion").value;

  return (!zipCode || (zipCode || "") == "") && (!subregion && (isNaN(Number(subregion)) || Number(subregion) <= 0)) ? { zipOrSubRegionReqired: true } : null;
};
